module.exports = __webpack_public_path__ + "img/404.1e30dc42.svg";